import { render, staticRenderFns } from "./TabTable.vue?vue&type=template&id=eb2ae94a&scoped=true&"
import script from "./TabTable.vue?vue&type=script&lang=ts&"
export * from "./TabTable.vue?vue&type=script&lang=ts&"
import style0 from "./TabTable.vue?vue&type=style&index=0&id=eb2ae94a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2ae94a",
  null
  
)

export default component.exports